import {
  Button,
  Tabs,
  TabsList,
  TabsTrigger,
} from '@growdash/design-system/atoms';
import PageWithTitle from '@growdash/growintel/components/hocs/with-title';
import SelectBrand from '@growdash/growintel/components/molecules/select-brand';
import { Brand } from '@growdash/growintel/generated';
import useTabState from '@growdash/growintel/hooks/useTabState';
import { useState } from 'react';
import { AiTab } from './types';
import MenuGenerateView from './views/menu-generate';
import MenuReviewView from './views/menu-review';
import MenuAiOnboardingDialog from './onboarding-dialog';

type Props = {};

export default function AiPage({}: Props) {
  const { updateTabState, activeSubTab, filters } = useTabState('ai');
  const [tempMenuGenBrand, setTempMenuGenBrand] = useState<
    Brand | undefined | null
  >(filters.menuGenerateBrand);

  const [tempMenuRevBrand, setTempMenuRevBrand] = useState<
    Brand | undefined | null
  >(filters?.menuReviewBrand);

  const tabs: {
    label: string;
    value: AiTab;
  }[] = [
    {
      label: 'Menu Generation',
      value: 'menu-generate',
    },
    {
      label: 'Menu Review',
      value: 'menu-review',
    },
  ];

  const handleChangeTab = (val: AiTab) => {
    updateTabState({
      selectedSubTab: val,
    });
  };

  const handleSubmit = () => {
    if (activeSubTab === ('menu-review' satisfies AiTab)) {
      updateTabState({
        filters: {
          ...filters,
          menuReviewBrand: tempMenuRevBrand,
        },
      });
      return;
    } else {
      updateTabState({
        filters: {
          ...filters,
          menuGenerateBrand: tempMenuGenBrand,
        },
      });
    }
  };

  return (
    <>
    <MenuAiOnboardingDialog/>
    
    <PageWithTitle title="Menu AI">
      <div className="flex mb-4 gap-4 items-center">
        <Tabs
          value={activeSubTab ?? 'menu-generate'}
          onValueChange={(v) => {
            handleChangeTab(v as AiTab);
          }}
        >
          <TabsList>
            {tabs.map((t) => {
              return (
                <TabsTrigger key={t.value} value={t.value} className="px-4">
                  {t.label}
                </TabsTrigger>
              );
            })}
          </TabsList>
        </Tabs>

        <SelectBrand
          value={
            activeSubTab === 'menu-generate'
              ? (tempMenuGenBrand?.id ?? '')
              : (tempMenuRevBrand?.id ?? '')
          }
          onValueChange={(brand) => {
            if (activeSubTab === ('menu-generate' satisfies AiTab)) {
              setTempMenuGenBrand(brand);
              return;
            }
            if (activeSubTab === ('menu-review' satisfies AiTab)) {
              setTempMenuRevBrand(brand);
            }
          }}
        />
        <div className="w-full justify-end flex">
          <Button
            onClick={handleSubmit}
            disabled={
              (activeSubTab === 'menu-generate' && !tempMenuGenBrand) ||
              (activeSubTab === 'menu-review' && !tempMenuRevBrand)
            }
          >
            {activeSubTab === 'menu-generate' && 'New Menu Ideas'}
            {activeSubTab === 'menu-review' && 'Review Menu'}
          </Button>
        </div>
      </div>
      {activeSubTab === 'menu-generate' && <MenuGenerateView />}
      {activeSubTab === 'menu-review' && <MenuReviewView />}
    </PageWithTitle>
    </>
  );
}
